/* eslint-disable */
import React from "react";
import { Method } from "../../../controls/Method";
import { useParameter } from "../../../shared";
import { UNIT_USD_BU, UNIT_USD_MT, UOM_UNITS } from "../constants";

const items = [
  { id: UNIT_USD_MT, name: "USD/MT" },
  { id: UNIT_USD_BU, name: "USD/BU, if applicable" },
];

export const UomControl: React.FC = React.memo(() => {
  const [units, setUnits] = useParameter<number[]>("@units");
  // same rule as the table: the unit that comes first in @units wins
  const buIndex = units?.indexOf(UNIT_USD_BU) ?? -1;
  const mtIndex = units?.indexOf(UNIT_USD_MT) ?? -1;
  const value = buIndex !== -1 && (mtIndex === -1 || buIndex < mtIndex) ? UNIT_USD_BU : UNIT_USD_MT;

  const onChange = (uom: number) => setUnits(UOM_UNITS[uom]);

  return <Method label="UOM" items={items} value={value} onChange={onChange} />;
});
